module.exports = __webpack_public_path__ + "static/media/ipo_image.dea495e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ipo_image.png
// module id = 493
// module chunks = 0